import React, { useState, useEffect, useRef } from 'react';

/**
 * Menú ⋮ de acciones (las acciones de fila/sección van en un kebab, nunca como
 * botones sueltos). acciones: [{ label, onClick, danger? }]
 */
export const MenuAcciones = ({ acciones, label = 'Acciones' }) => {
  const [abierto, setAbierto] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!abierto) return undefined;
    const cerrar = (e) => { if (!ref.current?.contains(e.target)) setAbierto(false); };
    document.addEventListener('mousedown', cerrar);
    return () => document.removeEventListener('mousedown', cerrar);
  }, [abierto]);
  return (
    <div className="consumo-menu" ref={ref}>
      <button
        type="button"
        className="consumo-menu-btn"
        aria-label={label}
        aria-expanded={abierto}
        onClick={() => setAbierto((v) => !v)}
      >
        ⋮
      </button>
      {abierto && (
        <div className="consumo-menu-lista" role="menu">
          {acciones.map((a) => (
            <button
              key={a.label}
              type="button"
              role="menuitem"
              className={`consumo-menu-item ${a.danger ? 'danger' : ''}`}
              onClick={() => { setAbierto(false); a.onClick(); }}
            >
              {a.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
